module.exports = __webpack_public_path__ + "img/games-logo.037bf60d.jpg";